"use strict";
import React from "react";
import classNames from "classnames";
const types = {
  info: {
    iconClass: "icon-info",
    alertClass: "alert-box--highlight"
  }
};
export default function Notification(props) {
  const typeDetails = types[props.type || "info"] || types["info"];
  const alertClasses = classNames({
    [typeDetails.alertClass]: true,
    "alert-box--flex": true,
    "mb-1": true
  });
  const iconClasses = classNames({
    icon: true,
    [typeDetails.iconClass]: true,
    "icon--no-repeat": true,
    "icon--sm": true,
    "mr-2": true
  });
  return /* @__PURE__ */ React.createElement("div", { className: alertClasses, "data-component": "Notification" }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("span", { className: iconClasses }), /* @__PURE__ */ React.createElement("span", { className: "mr-2" }, /* @__PURE__ */ React.createElement("strong", null, props.title)), /* @__PURE__ */ React.createElement("span", null, props.body)), props.action && /* @__PURE__ */ React.createElement("div", null, props.action));
}
